export const INTRO_TEXT = {
  FIRST: 'Welcome to our beauty salon located in woolloongabba, where beauty meets tranquility.',

  SECOND: `Experience professional hair care, rejuvenation treatment, and personalized styling
  services here. We will show you your natural beauty with our professional hands.
  Discover the best beauty experiences at our salon on woolloongabba.`,

  THIRD: `Every visit to our salon is a personalized experience, tailored to meet your
  individual needs. We take pride in offering excellent customer service and a wide
  array of beauty options.`,
} as const;

export const SERVICES_NOTE_TEXT = [
  'All prices depends on length and thickness of the hair.',

  'To avoid cancellation, please notify us if you are running more than 10 minutes late.',

  `We do not offer refunds for salon services and products. However, if you are not
  satisfied with the salon service results, please notify us within 7 business days.`,

  'We offer a one-time adjustment with the same stylist at no additional cost.',
];

export const CONTACT_QUESTIONS = [
  {
    question: 'DO YOU ACCEPT WALK-IN APPOINTMENTS?',
    answer:
      'While we prefer appointments, walk-ins are also welcome. However, if we have a high volume of appointments(if the salon is busy), we may not be able to accommodate walk-in customers. Therefore, we recommend making an appointment.',
  },
  {
    question: 'WHERE SHOULD I PARK?',
    answer:
      "In the shopping complex where our salon is located, there is a large supermarket Coles, and there is an underground parking lot on the lower floor. Free parking for up to 3 hours is available. The entrance to the parking lot is located at the back on Gibbon St. Please don't take the main road. Instead, enter from the side road and park in the Coles underground parking.",
    isParking: true,
  },
  {
    question: 'HOW DO I GET THERE BY WALKING?',
    answer:
      'Walk from Coles towards the woollongabba Hotel, and you will see Joa Hair on the right-hand side.',
  },
  {
    question: 'WHAT IF I AM UNHAPPY WITH MY HAIR SERVICE?',
    answer:
      'At Joa Hair Salon we strive for top-notch service, and we always guarantee our work. If you are not completely satisfied with your hair, please contact our guest services team within 7 days of your appointment by calling us at 0494 112 551 or emailing Joahair@hotmail.com with photos explaining the issue and our salon manager will be happy to schedule you in for a fix.',
  },
];

export const ABOUT_INTRODUCE_TEXT = [
  `We are Korean professional hair salon at Gabba central in Woolloongabba. 'Joa' means 'good' in Korean. Our salon is named with the hope that all our customers leave with a good heart and a good appearance.`,

  'At Joa Hair, we are composed of top hairstylists from Korea and Japan, each with over 10 years of experience. we boast excellent transportation and accessibility. Customer satisfaction is our top priority. We are a client-centric salon where our hairstylists care for you from start to finish, aiming to provide the best experience in a cozy and comfortable atmosphere. We strive to offer our customers the utmost experience in a warm and inviting environment.',

  'Relax with our comfortable and excellent service. We hope all good things come to your daily life :)',
];

export const PROMISE_TEXT = [
  {
    title: 'One-time Adjustment',
    text: `Your satisfaction is our priority. If you're not satisfied with the salon service results,
        you can receive a complimentary one-time adjustment with the same stylist to perfect your look.`,
  },
  {
    title: 'Professional Care',
    text: 'All products we use are professional and have proven effeciency. No compromises.',
  },
  {
    title: 'Personalized Experience',
    text: 'Each guest is our favorite guest. Come and experience exceptional service.',
  },
  {
    title: 'We Love What We Do',
    text: 'We loves what we do. Come and make sure there is a difference.',
  },
];
